import { Link, useNavigate, useParams } from 'react-router-dom'
import { Table, useApiQuery, type Column } from 'grabbitbot-legacy-ui'
import { screenerClient } from '../../api'
import { momentumStatusBadgeVariant, momentumStatusLabel } from '../../rules/momentumStatus'
import type { Momentum } from '../../api/types'

/** Equivalent of legacy `MomentumListComponent` (audit §3/§6). */
export function MomentumListPage() {
  const { exchangeId = '', tradingType = '' } = useParams<{ exchangeId: string; tradingType: string }>()
  const navigate = useNavigate()
  const { data, loading, error, refetch } = useApiQuery(
    () => screenerClient.searchMomentums(exchangeId, tradingType),
    [exchangeId, tradingType],
  )

  async function remove(id: string) {
    await screenerClient.deleteMomentum(exchangeId, tradingType, id)
    refetch()
  }

  const columns: Column<Momentum>[] = [
    {
      key: 'name',
      label: 'Name',
      align: 'left',
      format: (_v, row) => <Link to={`/${exchangeId}/${tradingType}/momentums/${row.id}`}>{row.name}</Link>,
    },
    { key: 'indicator', label: 'Indicator', align: 'left' },
    { key: 'intervals', label: 'Intervals', align: 'left', format: (v) => (Array.isArray(v) ? v.join(', ') : '') },
    {
      key: 'status',
      label: 'Status',
      format: (v) => {
        const variant = momentumStatusBadgeVariant(v as number)
        return (
          <span className={variant ? `screener-badge screener-badge--${variant}` : 'screener-badge'}>
            {momentumStatusLabel(v as number)}
          </span>
        )
      },
    },
    {
      key: 'id',
      label: '',
      sortable: false,
      format: (_v, row) => (
        <button type="button" onClick={() => row.id && remove(row.id)}>
          Delete
        </button>
      ),
    },
  ]

  return (
    <div>
      <div className="screener-page-title">
        <h1>
          Momentums <small>({exchangeId} · {tradingType})</small>
        </h1>
        <button type="button" onClick={() => navigate(`/${exchangeId}/${tradingType}/momentums/new`)}>
          New momentum
        </button>
      </div>
      {loading && <p>Loading…</p>}
      {error && <p role="alert">Could not load momentums.</p>}
      {data && <Table columns={columns} rows={data} rowKey={(row, i) => row.id ?? i} initialSort={{ key: 'name', dir: 'asc' }} />}
    </div>
  )
}
